module.exports = __webpack_public_path__ + "img/Audiocodes.bb4ca53f.svg";